// extracted by mini-css-extract-plugin
export var cardHeader = "_dx-0";
export var reorderHandle = "_dx-3";
export var titleArea = "_dx-1";
export var titleAreaWithHandle = "_dx-2";